import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private translocoService: TranslocoService) {
    super();
    this.initTranslations();
  }

  private initTranslations() {
    this.itemsPerPageLabel = this.translocoService.translate('PAGINATOR.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translocoService.translate('PAGINATOR.NEXT_PAGE');
    this.previousPageLabel = this.translocoService.translate('PAGINATOR.PREVIOUS_PAGE');
    this.changes.next(); // Notifica cambios al paginador
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const from = this.translocoService.translate('PAGINATOR.FROM');
    const of = this.translocoService.translate('PAGINATOR.OF');
    if (length === 0 || pageSize === 0) {
      return `0 ${of} ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${of} ${length}`;
  };
}
